export default function Why() {
  const reasons = [
    {
      title: 'Rapid Growth',
      description: 'Padel is one of the fastest-growing sports in Europe, capturing the attention of players across all demographics and skill levels.',
    },
    {
      title: 'Market Gap',
      description: 'The UK market lacks premium indoor padel venues that offer more than just courts—spaces that provide a complete experience.',
    },
    {
      title: 'Experience First',
      description: 'The GodPadel™ focuses on experience, design, and community, not volume. Quality over quantity, always.',
    },
  ];

  return (
    <section className="py-32 bg-[#231D17] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#B78A44] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#E5C478] rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-serif text-5xl md:text-6xl font-bold text-[#E5C478] mb-20 text-center tracking-wide">
            Why The GodPadel™
          </h2>

          <div className="grid md:grid-cols-3 gap-12">
            {reasons.map((reason, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-[#2A2318] to-[#231D17] p-10 rounded-lg border border-[#B78A44]/20 hover:border-[#B78A44]/40 transition-all duration-500 shadow-xl"
              >
                <div className="w-16 h-1 bg-[#B78A44] mb-8"></div>
                <h3 className="font-serif text-2xl font-bold text-[#E5C478] mb-6">
                  {reason.title}
                </h3>
                <p className="text-base text-[#F0E1C2]/80 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-20 text-center">
            <p className="text-lg md:text-xl text-[#F0E1C2]/90 max-w-3xl mx-auto leading-relaxed italic">
              "Excellence is not an act, but a habit. The GodPadel™ embodies this philosophy in every detail."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
